<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('inquiryorder:page')">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="6" :sm="24">
              <a-form-item label="">
                <a-input v-model="queryParam.name" allow-clear placeholder="请输入名称进行搜索" />
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a-button type="primary" style="margin-left: 8px" @click="visible=true">+添加轮播图</a-button>
              </span>
            </a-col>

          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert" :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection">
        <span slot="platform" slot-scope="text, record">
          {{ record.platform == '1' ? '医生端' : record.platform == '2'? '患者端' : '' }}
        </span>
        <span slot="orgId" slot-scope="text, record">
          {{ record.orgId == '1'? '通海县人民医院互联网医院管理平台' : '' }}
        </span>
        <span slot="state" slot-scope="text, record">
          <span v-if="record.state == 0">未发布</span>
          <a v-else>已发布</a>
          <!-- {{ record.state == '0' ? '未发布' : record.state == '1'? '已发布' : '' }} -->
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="$refs.addForm.add(record,1)" style="margin-right: 10px;">查看</a>
          <a @click="$refs.addForm.add(record,2)" style="margin-right: 10px;">编辑</a>
          <a style="margin-right: 10px;" @click="release(record)" v-if="record.state == 0">发布</a>
          <a @click="deleteItem(record)">删除</a>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
      <a-modal title="添加轮播图" :width="900" :visible="visible" @cancel="handleCancel">
        <template #footer>
          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary" :loading="confirmLoading" @click="addList">添加</a-button>
        </template>
        <a-form :form="form">
          <a-row :gutter="24">
            <a-col :md="12">
              <a-form-item label="图片名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <!-- <a-radio v-model="form.isChecked" :checked="checked">已完成评估工作</a-radio> -->
                <a-input v-model="form.name" placeholder="请输入图片名称" />
              </a-form-item>
            </a-col>
            <a-col :md="12">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="12">
              <a-form-item label="所属平台" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-radio-group name="radioGroup" v-model="form.platform">
                  <!-- <a-radio value="1">医生端</a-radio> -->
                  <a-radio value="2">患者端</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="12">
              <a-form-item label="详细页地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="form.url" placeholder="请输入详细页地址" />
              </a-form-item>
            </a-col>
            <a-col :md="12">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="24" style="padding-left:9px;padding-right: 165px;">
              <a-form-item label="权重" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">
                <a-input-number v-model="form.weight" :min="1" :max="15" placeholder="请输入权重" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="24" style="padding-left:9px;padding-right: 165px;">
              <a-form-item label="上传图片" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">

                <a-upload name="avatar" list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
                  :customRequest="fileUpdate" :before-upload="beforeUpload">
                  <img v-if="imageUrl" style="width:162px;height:162px" :src="imageUrl" alt="">
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </a-upload>
                <span>建议尺寸120*90像素，大小不要超过2M</span>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
import { pictureQuery, pictureDelete, pictureRelease, pictureAdd, pictureUpdate } from '@/api/modular/interhospital/picture/pictureMange'
  import addForm from './viewDetial.vue'
import editForm from './editForm.vue'

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        imageUrl : '',
        loading : false,
        checked: 0,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 19 }
        },
        form: {
          orgId: '1',
          platform : '2'
        },
        visible : false,
        confirmLoading: false,
        
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          orgId: '1',
          pageNo: 1,
          pageSize: 10,
          name : ''
        },
        // 表头
        columns: [
          {
            title: '创建时间',
            align: 'center',
            dataIndex: 'ctstamp',
          },
          {
            title: '图片名称',
            align: 'center',
            dataIndex: 'name'
          },
          {
            title: '所属机构',
            align: 'center',
            dataIndex: 'orgId',
            scopedSlots: { customRender: 'orgId' },
          },
          {
            title: '所属平台',
            align: 'center',
            dataIndex: 'platform',
            scopedSlots: { customRender: 'platform' },
          },
          {
            title: '权重',
            align: 'center',
            dataIndex: 'weight',
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'state',
            scopedSlots: { customRender: 'state' },
          },
        ],
        
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: () => {
          return pictureQuery(this.queryParam).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('inquiryorder:edit') || this.hasPerm('inquiryorder:delete')) {
        this.columns.push({
          title: '操作',
          align : 'center',
          width: '170px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      // 关闭完成情况弹框
      handleCancel() {
        this.visible = false;
        this.form = {};
      },

      // 删除
      inquiryorderDelete (record) {
        inquiryorderDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },

      // 提交时间
      handlDate(date, dateString) {
        this.queryParam.ctstamp = dateString
      },
     
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
     
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('建议上传图片大小不超过2MB!');
        }
        return isLt2M;
      },


      // 删除
      deleteItem(record) {
        let params = {
          id: record.id,
          useflag : 0,
        };
        pictureDelete(params).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功');
            this.handleOk();
          } else {
            this.$message.error('删除失败')
          }
        })
      },
      // 发布
      release(record) {
        let params = {
          carouselId: record.id,
          state: 1
        };
        pictureRelease(params).then(res => {
          if (res.code == 200) {
            this.$message.success('发布成功');
            this.handleOk();
          } else {
            this.$message.error('发布失败')
          }
        })
      },

      // 添加公告
      addList() {
        this.confirmLoading = true;
        this.imageUrl = '';
        pictureAdd(this.form).then(res => {
          this.confirmLoading = false;
          if (res.code == 200) {

            this.$message.success('添加成功');
            this.handleOk();
            this.handleCancel();
          } else {
            this.$message.error('添加失败');
            this.handleCancel();
          }
        })
      },

      // 自定义文件上传
      fileUpdate(file) {
        const form = new FormData();
        form.append('file', file.file);
        pictureUpdate(form).then(res => {
          if (res.code == 200) {
            this.form.photoUrl = res.data;
            this.imageUrl = res.data;
          } else {
            this.$message.error('上传图片失败')
          }
        })
      }
    }
  }
</script>
<style lang="less">

  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
    .avatar-uploader>.ant-upload {
      width: 128px;
      height: 128px;
    }
  
    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }
  
    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
</style>
